import React from "react";
import { Link } from "react-router-dom";
import { MAX_CHANNEL_LINK } from "@/config/links";
import { LANDING } from "@/constants/testIds";
import { trackClick } from "@/lib/track";
import LOGO_ICON_URL from "@/assets/hero-avatar.webp";

const Footer = () => {
  return (
    <footer className="border-t border-line bg-night-950 py-12 text-muted-foreground">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="mb-8 flex flex-col items-center justify-between gap-6 sm:flex-row sm:items-start">
          <Link to="/" className="flex items-center gap-2.5">
            <img src={LOGO_ICON_URL} alt="" className="h-9 w-9 rounded-full border border-line object-cover" />
            <span className="font-serif text-xl text-cream">Сказки</span>
          </Link>

          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm">
            <Link to="/stories" className="transition-colors hover:text-amber-soft">
              Сказки
            </Link>
            <Link to="/lullabies" className="transition-colors hover:text-amber-soft">
              Колыбельные
            </Link>
            <Link
              data-testid={LANDING.footerBotLink}
              to="/chat"
              onClick={() => trackClick("chat")}
              className="transition-colors hover:text-amber-soft"
            >
              Сделать сказку
            </Link>
            <a
              data-testid={LANDING.footerChannelLink}
              href={MAX_CHANNEL_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackClick("channel")}
              className="transition-colors hover:text-amber-soft"
            >
              MAX-канал
            </a>
          </nav>
        </div>

        <p className="mb-6 text-center text-xs leading-relaxed text-dim sm:text-left">
          <span
            className="mr-2 inline-flex h-8 w-8 items-center justify-center rounded-full border border-line align-middle text-[11px] font-bold text-cream"
            aria-label="0 плюс"
          >
            0+
          </span>
          Сказки и колыбельные создаёт искусственный интеллект по заданной теме. Развлекательный формат для семейного
          чтения — не консультация психолога или педагога. Самозанятый Садков Е. А., ИНН 732894935375. Вопросы, претензии и
          возвраты:{" "}
          <a href="mailto:mmski2002@gmail.com" className="transition-colors hover:text-amber-soft">
            mmski2002@gmail.com
          </a>
        </p>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-line pt-6 text-xs text-dim sm:flex-row">
          <span>© {new Date().getFullYear()} Сказки</span>
          <span className="flex items-center gap-5">
            <a href="/oferta" className="transition-colors hover:text-amber-soft">
              Оферта
            </a>
            <a href="/privacy" className="transition-colors hover:text-amber-soft">
              Политика конфиденциальности
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
